import React, { Component, useEffect, useState, CSSProperties } from 'react'
import functions from '../utils/functions'
import { Link, useHistory } from 'react-router-dom';
import $ from 'jquery'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ajax from '../utils/ajax';


const SlidersHead = (props) => {


    const [mostClickList, setMostClickList] = useState(false);
    const [userId, setUserId] = useState(functions.sessionGuard())
    const nav = useHistory();


    const settings = {
        dots: false,
        speed: 1000,
        autoplaySpeed: 5000,
        autoplay: true,
        infinite: true,
        slidesToShow: mostClickList.length < 1 ? 2 : 1,
        pauseOnHover: true,
        slidesToScroll: 1,
        arrows:false,
        initialSlide: 1,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: mostClickList.length < 3 ? 2 : 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },


            {
                breakpoint: 600,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 540,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 992,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    centerMode: false,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div>

            <div class="team4-slider-area" >

                {/* <h1>gdafafadf</h1> */}

                <Slider {...settings}>

  <div class="img1">
                        <img src="assets/img/all-images/hero/hero-img16.png" alt="" />
                      </div>

                      <div class="img1">
                        <img src="assets/img/all-images/hero/hero-img17.png" alt="" />
                      </div>

                      <div class="img1">
                        <img src="assets/img/all-images/hero/hero-img18.png" alt="" />
                      </div>

                </Slider>
            </div>

        </div>
    )
}
export default SlidersHead;